import { render } from "./PointHistoryUsageInfo.vue?vue&type=template&id=2b7bbf6e&ts=true"
import script from "./PointHistoryUsageInfo.vue?vue&type=script&lang=ts"
export * from "./PointHistoryUsageInfo.vue?vue&type=script&lang=ts"

import "./PointHistoryUsageInfo.vue?vue&type=style&index=0&id=2b7bbf6e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__